import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter} from 'react-router-dom';



ReactDOM.render(

  <BrowserRouter>
    <App  text="Your custom event!" />
  </BrowserRouter>,
  // <React.StrictMode>
  //   <App text="Your custom event!" />
  // </React.StrictMode>,
  document.getElementById('root')
);

